namespace TabAurous.Inventory {
    export interface OpeningStockForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        PartyId: Serenity.LookupEditor;
        TermsId: Serenity.IntegerEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.IntegerEditor;
        GSTState: Serenity.StringEditor;
        ProductItemImage: Serenity.ImageUploadEditor;
        ItemDetails: OpeningStockItemsEditor;
        ShipmentId: Serenity.IntegerEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        Remark: Serenity.TextAreaEditor;
        ShipAddressId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class OpeningStockForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.OpeningStock';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OpeningStockForm.init)  {
                OpeningStockForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.LookupEditor;
                var w5 = s.ImageUploadEditor;
                var w6 = OpeningStockItemsEditor;
                var w7 = s.DecimalEditor;
                var w8 = s.TextAreaEditor;

                Q.initFormType(OpeningStockForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'TransId', w2,
                    'VoucherNo', w2,
                    'VoucherTypeId', w3,
                    'PartyId', w4,
                    'TermsId', w3,
                    'BillNo', w2,
                    'BillDate', w0,
                    'ChallanNo', w2,
                    'ChallanDate', w0,
                    'UserId', w4,
                    'EmployeeId', w3,
                    'GSTState', w2,
                    'ProductItemImage', w5,
                    'ItemDetails', w6,
                    'ShipmentId', w3,
                    'Pieces', w3,
                    'Weight', w7,
                    'NetWeight', w7,
                    'NetAmount', w7,
                    'GrossAmount', w7,
                    'Remark', w8,
                    'ShipAddressId', w3,
                    'FinancialYearId', w3,
                    'CompanyId', w3
                ]);
            }
        }
    }
}
